import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, Users, Clock } from "lucide-react";

export default function Hero({ onCtaClick }) {
  return (
    <section
      className="relative overflow-hidden pt-32 md:pt-40 pb-20 md:pb-32 grain"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1634634465913-5bb5600942f2?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt=""
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-950/85 to-slate-950" />
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#38BDF8]/10 blur-[120px]" />
        <div className="absolute top-40 -left-40 w-[400px] h-[400px] rounded-full bg-blue-500/10 blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        {/* Urgency pill */}
        <div
          className="animate-fade-up inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs md:text-sm font-medium text-slate-200"
          data-testid="hero-urgency-pill"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#38BDF8] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#38BDF8]"></span>
          </span>
          Live Batch Filling Fast — <span className="text-[#38BDF8] font-semibold">Only 15 Seats Left</span>
        </div>

        <h1
          className="animate-fade-up delay-100 font-display text-3xl sm:text-4xl lg:text-6xl font-normal tracking-normal text-white mt-6 max-w-5xl leading-[1.2]"
          data-testid="hero-headline"
        >
          Manual Testing is dying...{" "}
          <span className="relative inline-block">
            <span className="text-[#38BDF8]">AI</span>
            <span className="text-slate-300"> is replacing Manual Testers</span>
          </span>
          <br />
          <span className="text-slate-300"> Transform into</span>
          <span className="text-[#38BDF8]"> GenAI Automation Testing </span>
          <span className="text-slate-300"> in </span>
          <span className="text-[#38BDF8]">  90 </span>
          <span className="text-slate-300"> days...</span>
          <br />
        </h1>

        <p
          className="animate-fade-up delay-200 mt-8 text-lg md:text-xl text-slate-300 max-w-2xl leading-relaxed"
          data-testid="hero-subheadline"
        >
          Tired of the same salary, same bugs, same stagnant role? Learn
          <span className="text-white font-medium"> Selenium, Cucumber BDD, Playwrights & Framework Building </span>
          the AI-powered way — designed for Indian manual testers with
          <span className="text-[#38BDF8] font-semibold"> zero coding fear.</span>
        </p>

        <div className="animate-fade-up delay-300 mt-10 flex flex-col sm:flex-row gap-4">
          <Button
            onClick={onCtaClick}
            className="btn-yellow font-bold uppercase tracking-wider text-sm h-14 px-8 rounded-full group"
            data-testid="hero-cta-primary"
          >
            Book My Seat @99/- Only
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>
          <a
            href="#curriculum"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 rounded-full border border-slate-700 hover:border-slate-500 text-white font-medium transition-colors"
            data-testid="hero-cta-secondary"
          >
            See Curriculum
          </a>
        </div>

        {/* Stats strip */}
        <div className="animate-fade-up delay-400 mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl">
          {[
            { icon: Users, value: "2000+", label: "Students Trained" },
            { icon: Sparkles, value: "AI-Powered", label: "Curriculum" },
            { icon: Clock, value: "7–8 Wks", label: "Weekend Batch" },
            { icon: Users, value: "4.9 / 5", label: "71 Reviews" },
          ].map((s, i) => (
            <div
              key={i}
              className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl p-4"
              data-testid={`hero-stat-${i}`}
            >
              <s.icon className="w-5 h-5 text-[#38BDF8] mb-2" />
              <div className="font-display text-2xl font-normal text-white">{s.value}</div>
              <div className="text-xs text-slate-400 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
